<template>
  <div class="row">
    <div class="col-xl-6">
      <template v-if="data.codesNSF && Object.keys(data.codesNSF).length">
        <p class="fw-bold textStyle">{{ $t("training.rncp.nsf_codes") }}</p>
        <template v-for="codeNSF in data.codesNSF" :key="codeNSF.code">
          <p>
            <span class="fw-bold">{{ codeNSF.code }}</span> {{ codeNSF.title }}
          </p>
        </template>
      </template>

      <template v-if="data.formacodes && Object.keys(data.formacodes).length">
        <p class="fw-bold textStyle mt-4">{{ $t("training.rncp.form_codes") }}</p>
        <template v-for="formacode in data.formacodes" :key="formacode.code">
          <p>
            <span class="fw-bold">{{ formacode.code }}</span> {{ formacode.title }}
          </p>
        </template>
      </template>
    </div>
    <div class="col-xl-6">
      <template v-if="data.codesROME && Object.keys(data.codesROME).length">
        <p class="fw-bold textStyle">{{ $t("training.rncp.rome_codes") }}</p>
        <template v-for="codeROME in data.codesROME" :key="codeROME.code">
          <p>
            <span class="fw-bold">{{ codeROME.code }}</span> {{ codeROME.title }}
          </p>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainingRncpAccordionClassificationComponent",
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
